import { create, type StateCreator } from 'zustand';
import { devtools } from 'zustand/middleware';

type State = {
  openerUrl: string | null;
  messagePort: MessagePort | null;
  isConnected: boolean;
  remainOpen: boolean;
};

type Actions = {
  setOpenerUrl: (url: string | null) => void;
  setMessagePort: (port: MessagePort | null) => void;
  setIsConnected: (connected: boolean) => void;
  setRemainOpen: (remainOpen: boolean) => void;
};

type MessageChannelStore = State & Actions;

const messageChannelStore: StateCreator<MessageChannelStore> = (set) => ({
  openerUrl: null,
  messagePort: null,
  isConnected: false,
  remainOpen: false,
  setOpenerUrl: (url) => set({ openerUrl: url }),
  setMessagePort: (port) => set({ messagePort: port }),
  setIsConnected: (connected) => set({ isConnected: connected }),
  setRemainOpen: (remainOpen) => set({ remainOpen }),
});

export default create<MessageChannelStore>()(
  devtools(messageChannelStore, {
    name: 'Z Wallet: Message Channel Store',
  })
);
